import { useState } from "react";
import type { WSClient } from "./ws-client";

import "./AdminPanel.css";

type Props = {
  ws: WSClient;
};

export function AdminPanel({ ws }: Props) {
  const [timestamp, setTimestamp] = useState<string>("");

  const sendTime = () => {
    if (!/^\d{2}:\d{2}:\d{2}$/.test(timestamp)) {
      alert("Invalid time format. Use HH:MM:SS.");
      return;
    }

    ws.send({
      type: "set-time",
      timestamp,
    });
  };

  const allowBreak = () => {
    ws.send({ type: "allow-break" });
  };

  const reset = () => {
    ws.send({ type: "reset" });
  }

  return (
    <div className="admin-panel">
      <div>
        <div>
          <input
            type="text"
            placeholder="HH:MM:SS"
            value={timestamp}
            onChange={(e) => setTimestamp(e.target.value)}
          />
          <button onClick={sendTime}>Set Time</button>
        </div>
        <div>
          <button onClick={allowBreak}>Allow Break</button>
        </div>
        <div>
          <button onClick={reset}>Reset</button>
        </div>
      </div>
    </div>
  );
}
